// extracted by mini-css-extract-plugin
export default {"projectsBlock":"Projects_projectsBlock__5Nyuw","projectsContainer":"Projects_projectsContainer__lNdq3","projects":"Projects_projects__WVD-s"};